<template>
  <div class="users">
    <div class="row">
      <div class="flex md8">
        <va-card>
          <div class="row align--center">
            <div class="flex md6">
              <va-input
                :value="researchTerm"
                placeholder="Rechercher un template"
                @input="searchTemplate"
              >
                <va-icon name="fa fa-search" slot="prepend" />
              </va-input>
            </div>
          </div>
          <va-data-table
            class="va-table--hoverable va-table--stripped"
            :fields="fields"
            :data="filteredUsers"
            :no-data-label="$t('poissonnierTable.empty')"
            :per-page="parseInt(perPage)"
            @row-clicked="showUser"
            clickable
          >
            <template slot="actions" slot-scope="props">
              <va-popover message="Supprimer" placement="left">
                <va-button
                  flat
                  small
                  color="primary"
                  icon="fa fa-trash"
                  @click="deleteTemplate(props.rowData)"
                />
              </va-popover>
            </template>
          </va-data-table>
        </va-card>
      </div>
      <div class="flex md4">
        <va-card>Upload</va-card>
      </div>
    </div>
    <va-modal
      class="modal"
      v-model="showUserTrigger"
      :title=" $t('user.modalTitle') "
      cancelClass="none"
      :okText=" $t('ficheEntreprise.close') "
      max-width="100%"
      v-on:ok="saveUser"
      v-on:cancel="closeModal"
    >
      <div class="row forcewidth2">
        <div class="flex md12">
          <div class="row row-inside">
            <div class="flex xs10 md4 padded-right">
              <va-input v-model="userNom" placeholder="Nom" label="Nom" />
            </div>
            <div class="flex xs10 md4 padded-left padded-right">
              <va-input v-model="userPrenom" placeholder="Prénom" label="Prénom" />
            </div>
            <div class="flex md4 xs5">
              <va-select
                label="Droits"
                v-model="selectRight"
                textBy="description"
                :options="droitsOptions"
              />
            </div>
          </div>
          <div class="row row-inside">
            <div class="flex xs10 md8 padded-right">
              <va-input
                v-model="userEmail"
                placeholder="Courriel"
                label="Courriel"
                type="email"
                :success="emailChecker"
                :error="emailError"
                :error-messages="errorMsgEmail"
              />
            </div>
            <div class="flex xs10 md4">
              <va-input
                v-model="userName"
                placeholder="Username"
                label="Username"
                :error="userNameEmpty.check"
                :error-messages="userNameEmpty.message"
              />
            </div>
          </div>
          <div class="row row-inside" v-show="isNotNewUser">
            <div class="flex xs10 md4">
              <va-checkbox label="Réinitialiser le mot de passe" v-model="resetPassword" />
            </div>
          </div>
          <div class="row row-inside" v-show="resetPassword">
            <div class="flex xs10 md4">
              <va-checkbox label="Envoyer le mot de passe" v-model="sendByEmail" disabled />
            </div>
          </div>
          <div class="row row-inside" v-show="resetPassword && !sendByEmail">
            <div class="flex xs10 md6 padded-right">
              <va-input
                v-model="password"
                placeholder="Mot de passe"
                label="Mot de passe"
                type="password"
                :success="pwdSuccess"
                :error="pwdChecker.check"
                :error-messages="pwdChecker.message"
              />
            </div>
            <div class="flex xs10 md6 padded-left">
              <va-input
                v-model="passwordCheck"
                placeholder="Mot de passe"
                label="Vérifier le mot de passe"
                type="password"
                :success="pwdSuccess"
                :error="pwdChecker.check"
                :error-messages="pwdChecker.message"
              />
            </div>
          </div>
        </div>
      </div>
    </va-modal>

    <va-modal
      class="modal"
      v-model="showConfirmDelete"
      title="Suppression de l'utilisateur"
      :message="confirmDeleteMsg"
      cancelClass="none"
      :okText=" $t('ficheEntreprise.close') "
      max-width="100%"
      v-on:ok="confirmDelete"
      v-on:cancel="closeDeleteModal"
    />
  </div>
</template>

<script>
import axios from "axios";
import { debounce, findIndex } from "lodash";
import { validateEmail } from "../../services/utils";

export default {
  name: "users",

  data() {
    return {
      showConfirmDelete: false,
      confirmDeleteMsg: null,
      isAction: false,
      pwdEmpty: false,
      userNameEmpty: {
        check: false,
        message: ["L'email ou l'username doit exister"]
      },
      idutilisateurs: null,
      errorMsgEmail: null,
      isNotNewUser: false,
      resetPassword: true,
      sendByEmail: false,
      selectRight: 1,
      userName: null,
      userNom: null,
      userPrenom: null,
      userEmail: null,
      password: null,
      passwordCheck: null,
      researchTerm: null,
      perPage: 20,
      usersList: [],
      showUserTrigger: false,
      perPageOptions: ["4", "6", "10", "20"],
      droitsOptions: [
        { id: 0, description: "ADMIN" },
        { id: 1, description: "UTILISATEUR" }
      ],
      activeUser: null
    };
  },
  methods: {
    closeDeleteModal() {
      this.activeUser = null;
    },
    confirmDelete() {
      axios
        .delete("api/delete-user", { data: { user: this.activeUser } })
        .then(res => {
          this.launchEpicmaxToast("Utilisateur supprimé");
          this.loadUserList();
        })
        .catch(err => {
          this.launchEpicmaxToast("Erreur lors de la suppression");
          this.loadUserList();
        });

      this.showConfirmDelete = false;
    },
    deleteTemplate(template) {
      this.isAction = true;
      this.confirmDeleteMsg =
        "Voulez vous vraiment supprimer le template: " + template.name;
      this.activeUser = template;
      this.showConfirmDelete = true;
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000
      });
    },
    searchTemplate: debounce(function(researchTerm) {
      this.researchTerm = researchTerm;
    }, 400),
    resetUser() {
      this.isNotNewUser = false;
      this.resetPassword = true;
      this.sendByEmail = false;
      this.selectRight = this.droitsOptions[1];
      this.userName = null;
      this.userNom = null;
      this.userPrenom = null;
      this.userEmail = null;
      this.password = null;
      this.passwordCheck = null;
      this.userNameEmpty.check = false;
      this.idutilisateurs = null;
    },
    setUser(user) {
      this.isNotNewUser = true;
      this.resetPassword = false;
      this.sendByEmail = false;
      this.selectRight =
        user.droits === "ADMIN" ? this.droitsOptions[0] : this.droitsOptions[1];
      this.userName = user.username;
      this.idutilisateurs = user.idutilisateurs;
      this.userNom = user.nom;
      this.userPrenom = user.prenom;
      this.userEmail = user.email;
      this.password = null;
      this.passwordCheck = null;
    },
    showUser(user) {
      if (this.isAction) {
        this.isAction = false;
        return;
      }
      this.isNotNewUser = true;
      this.setUser(user);
      this.showUserTrigger = true;
    },
    closeModal() {
      this.resetUser();
      this.showUserTrigger = false;
    },
    async saveUser() {
      //intercept and prevent modal closing
      this.showUserTrigger = true;

      let interupt = false;
      this.pwdEmpty = false;

      // check that everything mandatory is set:
      if (!this.userName && (!this.userEmail || this.emailError)) {
        this.userNameEmpty.check = true;
        interupt = true;
      }

      console.log(this.sendByEmail);
      console.log(this.resetPassword);
      console.log(this.isNotNewUser);
      console.log(this.password);
      console.log(this.pwdChecker);
      if (
        !this.sendByEmail &&
        (this.resetPassword || !this.isNotNewUser) &&
        (!this.password || this.pwdChecker.check)
      ) {
        this.pwdEmpty = true;
        interupt = true;
      }
      if (interupt) {
        this.launchEpicmaxToast("L'utilisateur ne peut pas être créé");
        return;
      }
      let params = {
        userName: this.userName,
        email: this.userEmail,
        prenom: this.userPrenom,
        nom: this.userNom,
        droits: this.selectRight,
        password: this.password,
        // to send a reset email
        resetEmail: this.sendByEmail,
        resetPwd: this.resetPassword
      };
      // change url based on context (create or update)
      let url;
      if (this.isNotNewUser) {
        url = "update-user";
        params.idutilisateurs = this.idutilisateurs;
      } else {
        url = "create-user";
      }

      axios
        .post("/api/" + url, params)
        .then(res => {
          this.loadUserList();
          this.showUserTrigger = false;
        })
        .catch(err => {
          console.log(err.response.data);
          this.launchEpicmaxToast("L'utilisateur ne peut pas être créé");
        });
    },
    containSearch(term) {
      term = term.toString();
      return term.toLowerCase().includes(this.researchTerm.toLowerCase());
    },
    createUser() {
      this.isNotNewUser = false;
      this.resetUser();
      this.showUserTrigger = true;
    },
    loadUserList() {
      axios.get("/api/template-docx/list").then(resp => {
        console.log(resp.data);
        this.usersList = resp.data;
      });
    }
  },
  mounted() {
    this.loadUserList();
  },
  computed: {
    emailError() {
      if (this.userNameEmpty.check) {
        this.errorMsgEmail = this.userNameEmpty.message;
        return true;
      }

      if (!this.userEmail || this.userEmail.length < 1 || this.emailChecker) {
        this.errorMsgEmail = ["Courriel non valide"];
        return false;
      }

      this.errorMsgEmail = this.userNameEmpty.message;
      return true;
    },
    emailChecker() {
      return validateEmail(this.userEmail);
    },
    pwdSuccess() {
      if (
        this.passwordCheck &&
        this.password &&
        this.passwordCheck === this.password
      )
        return true;

      return false;
    },
    pwdChecker() {
      if (this.pwdEmpty) {
        return {
          check: true,
          message: ["Le mot de passe ne peut pas être vide"]
        };
      }
      if (
        !this.passwordCheck ||
        this.passwordCheck.length < 1 ||
        this.passwordCheck === this.password
      )
        return {
          check: false
        };

      return {
        check: true,
        message: ["Les mots de passes doivent correspondre"]
      };
    },
    filteredUsers() {
      if (!this.researchTerm || this.researchTerm.length < 1) {
        return this.usersList;
      }
      return this.usersList.filter(item => {
        return (
          this.containSearch(item.name) ||
          this.containSearch(item.iddocx_template)
        );
      });
    },
    fields() {
      return [
        {
          name: "iddocx_template",
          title: "id",
          sortField: "iddocx_template",
          width: "15%"
        },
        {
          name: "name",
          title: "Nom",
          sortField: "name",
          width: "15%"
        },
        {
          name: "__slot:actions",
          dataClass: "text-right",
          width: "10%"
        }
      ];
    }
  }
};
</script>

<style lang="scss">
.row-equal .flex {
  .va-card {
    height: 100%;
  }
}
.dashboard {
  .va-card {
    margin-bottom: 0 !important;
  }
}

.padded-right {
  padding-right: 1%;
}
.padded-left {
  padding-left: 1%;
}
.forcewidth2 {
  min-width: 50vw;
}
</style>
